/**
 * A dónde lleva «Solicitar acceso».
 *
 * El alta es solo por invitación: quien llega sin una no puede crear cuenta, y
 * se le manda a la sección de contacto/demo del landing. Se cambia sin tocar
 * código con `VUE_APP_CONTACT_URL` (build arg del Dockerfile).
 */
export const CONTACT_URL: string = process.env.VUE_APP_CONTACT_URL || 'https://ininvoice.com/#demo';
